import { api, useSuspenseQuery } from "../../../../hooks"

interface CodeStatus {
  status: "OK" | "NEVER_CREATED"
}

export const useLoadingDialog = () => {
  const { data: hasAccess } = useSuspenseQuery({
    queryKey: ["users", "security", "step-up", "code-status"],
    queryFn: () => api.get<CodeStatus>("/api/users/security/step-up/code-status"),
    select: (data) => data.status === "OK",
    staleTime: 0,
    gcTime: 0,
  })

  return { hasAccess }
}
